import type { HTMLAttributes, ReactNode } from "react";

interface GlassCardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  variant?: "default" | "elevated";
  accent?: "primary" | "secondary" | "tertiary" | "error" | "none";
  glow?: boolean;
}

const accentClass: Record<NonNullable<GlassCardProps["accent"]>, string> = {
  primary: "border-l-4 border-l-primary-fixed-dim",
  secondary: "border-l-4 border-l-secondary",
  tertiary: "border-l-4 border-l-tertiary-fixed-dim",
  error: "border-l-4 border-l-error",
  none: "",
};

export function GlassCard({
  children,
  variant = "default",
  accent = "none",
  glow = false,
  className = "",
  ...rest
}: GlassCardProps) {
  const base = variant === "elevated" ? "glass-card-elevated" : "glass-card";
  const glowClass = glow ? "shadow-cyan-glow" : "";
  return (
    <div className={`${base} rounded-lg ${accentClass[accent]} ${glowClass} ${className}`} {...rest}>
      {children}
    </div>
  );
}
